// Zone 2 calculator: age (plus optional resting heart rate) in, target ranges
// out. Formulas are cited on the page itself; keep them in sync with the copy.

const calc = document.querySelector("[data-calculator]")

// Tanaka, Monahan & Seals (2001): HRmax = 208 - 0.7 x age.
const maxHeartRate = (age) => Math.round(208 - 0.7 * age)

// Straight percent-of-max range.
const percentRange = (max, lo, hi) => [Math.round(max * lo), Math.round(max * hi)]

// Karvonen heart-rate-reserve range: ((max - rest) x intensity) + rest.
const reserveRange = (max, rest, lo, hi) => [
  Math.round((max - rest) * lo + rest),
  Math.round((max - rest) * hi + rest),
]

if (calc) {
  const ageInput = calc.querySelector("[data-calc-age]")
  const restInput = calc.querySelector("[data-calc-rest]")
  const maxOut = calc.querySelector("[data-calc-max]")
  const percentOut = calc.querySelector("[data-calc-percent]")
  const reserveOut = calc.querySelector("[data-calc-reserve]")
  const reserveRow = calc.querySelector("[data-calc-reserve-row]")

  const render = () => {
    const age = Number.parseInt(ageInput.value, 10)
    if (!Number.isFinite(age) || age < 10 || age > 100) {
      maxOut.textContent = "—"
      percentOut.textContent = "—"
      reserveRow.hidden = true
      return
    }

    const max = maxHeartRate(age)
    maxOut.textContent = `${max}`

    const [pLo, pHi] = percentRange(max, 0.6, 0.7)
    percentOut.textContent = `${pLo}–${pHi}`

    const rest = Number.parseInt(restInput.value, 10)
    if (Number.isFinite(rest) && rest >= 30 && rest <= 100 && rest < max) {
      const [rLo, rHi] = reserveRange(max, rest, 0.6, 0.7)
      reserveOut.textContent = `${rLo}–${rHi}`
      reserveRow.hidden = false
    } else {
      reserveRow.hidden = true
    }
  }

  ageInput.addEventListener("input", render)
  restInput.addEventListener("input", render)
  render()
}
